export default (color: string): [number, number, number, number] => {
  const clean = color.replace('#', '');

  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  const a = clean.length === 8 ? parseInt(clean.slice(6, 8), 16) : 255;

  return [
    +(r / 255).toFixed(3),
    +(g / 255).toFixed(3),
    +(b / 255).toFixed(3),
    +(a / 255).toFixed(3),
  ];
};
